export const OTP_ENABLED = 'user/OTP_ENABLED';
